import React, { useState, useEffect, useRef } from 'react'
import styles from './index.module.scss'
import Loading from '@/components/base/loading'

const Bill: React.FC = () => {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)
    const iframeRef = useRef<HTMLIFrameElement>(null)

    const savedToken = localStorage.getItem('business_web_token')

    // const batchCallUrl = savedToken
    //     ? `http://47.76.33.67:6005/ai/task/main?token=${encodeURIComponent(savedToken)}&autoLogin=true`
    //     : `http://47.76.33.67:6005/ai/task/main`


    // const businessWebUrl = 'http://47.76.33.67:6005'
    const businessWebUrl = 'https://combine-next.jarvisbro.com'
    // 构建带有样式参数的URL
    const styleParams = new URLSearchParams({
        hideHeader: 'true', nextCompat: 'r16',
    })
    const billUrl = `${businessWebUrl}/ai/account/balance?${styleParams.toString()}`

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false)
        }, 1300) // 1.3秒后自动关闭

        return () => clearTimeout(timer) // 清理定时器
    }, []) // 空依赖数组，只在组件挂载时执行一次

    return (
        <div className={styles.billContainer}>
            {loading && (
                <div className={styles.loadingContainer}>
                    <Loading />
                </div>
            )}
            <iframe
                ref={iframeRef}
                src={billUrl}
                className={styles.billIframe}
                title="Bill"
                sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation allow-downloads"
            />
        </div>
    )
}

export default Bill